module.exports = __webpack_public_path__ + "static/img/school-9.7535886.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-9.png
// module id = z1vv
// module chunks = 0